import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@/shared/api/reauth.api';

export const aggregationServiceApi = createApi({
	reducerPath: 'aggregation service',
	tagTypes: [],
	baseQuery: baseQueryWithReauth(AGGREGATION_API_URL),
	endpoints: () => ({}),
});
